import { apiBase } from "./apiHost";

/*
 * Where this app talks to.
 *
 * API_URL is no longer a constant. Which bridge a contest uses is decided at
 * boot by apiHost.js, because the Lumen -> Laravel cutover runs per contest and
 * this app cannot tell which side it is on without asking. Its defaults and the
 * per-environment fallbacks live there now; see API_URL below.
 */
const config = {
  /*
   * A GETTER, not a constant.
   *
   * Which bridge a contest talks to is decided at boot by apiHost.js. Reading
   * it at call time means every file that uses `config.API_URL` gets the right
   * host without any of them changing — they only ever read it as a property,
   * never destructure it.
   *
   * To pin the app at one host for development, set REACT_APP_BRIDGE_URL — it
   * becomes both the default and an accepted answer. (REACT_APP_API_URL is NOT
   * honoured; see the note on DEFAULT_BASE in apiHost.js.)
   */
  get API_URL() {
    return apiBase();
  },

  VIRAL_SHARE_URL:
    process.env.NODE_ENV === 'production'
      ? 'https://fe-contest.flexifunnels.com' // Production URL
      : 'http://localhost:3000', // Local URL

  // The contest ADMIN app (aicontest / flexiviral) — Laravel, not a bridge. It
  // owns the contests table, so it is what answers "which bridge is this
  // contest on?" before the first bridge call is made. Override with
  // REACT_APP_CONTEST_API_URL.
  CONTEST_API_URL:
    process.env.REACT_APP_CONTEST_API_URL ||
    (process.env.NODE_ENV === 'production'
      ? 'https://flexiviral.flexifunnels.com/api'
      : 'http://aicontest.local.com/api'),
};

export default config;
